/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A flavor specific representation of a verifiable crendential.
 */
export type CredentialDataModel = Truvity.CredentialDataModel.Vc11;

export namespace CredentialDataModel {
    export interface Vc11 extends Truvity.Credential11 {
        flavorName: 'VC1_1';
    }
}
